module.exports = __webpack_public_path__ + "media/images/affiliates/12x-4ece99499491cc54895664a46a73c707.svg";